import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import splitLongWords from 'utils/splitLongWords';

import OrderViewInformationSection from './OrderViewInformationSection';
import OrderViewInformationSectionTitle from './OrderViewInformationSectionTitle';

const OrderViewInformationReferralSource = props => (
  <OrderViewInformationSection>
    <Grid
      container
      direction="column"
      justify="flex-start"
      spacing={0}
    >
      <Grid item>
        <OrderViewInformationSectionTitle>
          Referral Source
        </OrderViewInformationSectionTitle>
      </Grid>
      <Grid item>
        <Typography gutterBottom>
          {splitLongWords(props['Referral Source']['Name of source'])}
        </Typography>
        <Typography variant="caption">
          {props['Referral Source']['Referral Source Contact'].map(item => item.Phone).join(', ')}
        </Typography>
      </Grid>
    </Grid>
  </OrderViewInformationSection>
);

OrderViewInformationReferralSource.propTypes = {
  'Referral Source': PropTypes.shape({
    'Name of source': PropTypes.string.isRequired,
    'Referral Source Contact': PropTypes.arrayOf(PropTypes.shape({
      Phone: PropTypes.string,
    })),
  }).isRequired,
};

export default OrderViewInformationReferralSource;



// WEBPACK FOOTER //
// ./src/components/workflow/OrderViewInformation/OrderViewInformationReferralSource.js